export default __webpack_public_path__ + "static/media/arrowLeftMoss.76ced3bd.svg";